
/**
 * this is just a simple
 * module that handles clearing of the search filter.
 */

function askQuestion(el, faq) {
  const $el = $(el);
  const $clear = $el.find('[data-js-faq-ask-clear]');
  const $clearContainer = $el.find('.Ge-AskQuestion-Clear');

  $clear
    .click((evt) => {
      evt.preventDefault();
      // set the params to undefined which
      // clears them.
      faq.setParams({
        category : undefined,
        commonSearch: undefined,
        query    : undefined
      });
    });

  faq.on('param', (params) => {
    let hasSearch = params.query || params.category;
    $clearContainer.toggleClass('Ge-AskQuestion-Clear--Hidden', !hasSearch);
  });
}

export default askQuestion;
